
/* eslint-disable import/no-cycle */
import {
  computed, defineComponent, onMounted, ref,
} from 'vue';
import { NETWORK_CONTACT_TYPES } from '@/types/enums';
import SpacesUserTransition from '@/modules/spaces/components/SpacesUserTransition.vue';
import SpacesUser from '@/modules/spaces/components/SpacesUser.vue';
import { useSpacesStore } from '@/modules/spaces/store/spacesStore';

export default defineComponent({
  components: {
    SpacesUserTransition,
    SpacesUser,
  },
  props: {
    usersToAdd: { type: Array as () => string[], default: [] as string[] },
    usersToInvite: { type: Array as () => string[], default: [] as string[] },
  },
  setup(props, context) {
    const spacesStore = useSpacesStore();
    const my = computed(() => spacesStore.myContacts);

    function handleUser(accountId: string) {
      context.emit('update-users', accountId);
    }

    return {
      spacesStore,
      my,
      NETWORK_CONTACT_TYPES,
      handleUser,
    };
  },
});
